import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    const start = group.get('startDate')?.value;
    const end = group.get('endDate')?.value;

    if (!start || !end) return null;
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (startDate > endDate) {
      return { dateRangeInvalid: true, message: 'Start date must be before end date' };
    }
    // 3 months = 92 days approx. Use precise comparison with months if needed
    const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);
    if (diffInDays > 92) {
      return { dateRangeExceedsThreeMonths: true, message: 'Date range cannot exceed 3 months' };
    }
    return null;
  };
}
